<template>
  <span
    class="d-inline-flex align-center covering-zone-badge flex-shrink-0"
    :class="[toneClass, { 'px-2 py-1 rounded covering-zone-badge--on-media': onMedia }]"
  >
    <span class="covering-zone-badge__pip mr-1 flex-shrink-0" aria-hidden="true" />
    <span class="text-caption font-weight-medium">
      {{ $t(`defects.coveringIrZone.${zone}`) }}
    </span>
  </span>
</template>

<script>
  export default {
    name: 'CoveringZoneBadge',
    props: {
      zone: { type: String, required: true },
      onMedia: { type: Boolean, default: false }
    },
    computed: {
      toneClass() {
        return `covering-zone-badge--${this.zone}`;
      }
    }
  };
</script>

<style scoped>
  .covering-zone-badge__pip {
    width: 8px;
    height: 8px;
    border-radius: 2px;
  }

  .covering-zone-badge--on-media {
    background-color: var(--v-surface-base);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.28);
  }

  .covering-zone-badge--zone1 {
    color: #0f766e;
  }
  .covering-zone-badge--zone1 .covering-zone-badge__pip {
    background-color: #0d9488;
  }
  .covering-zone-badge--zone2 {
    color: #0369a1;
  }
  .covering-zone-badge--zone2 .covering-zone-badge__pip {
    background-color: #0284c7;
  }
  .covering-zone-badge--zone3 {
    color: #b45309;
  }
  .covering-zone-badge--zone3 .covering-zone-badge__pip {
    background-color: #d97706;
  }

  .theme--dark .covering-zone-badge--zone1 {
    color: #5eead4;
  }
  .theme--dark .covering-zone-badge--zone1 .covering-zone-badge__pip {
    background-color: #2dd4bf;
  }
  .theme--dark .covering-zone-badge--zone2 {
    color: #7dd3fc;
  }
  .theme--dark .covering-zone-badge--zone2 .covering-zone-badge__pip {
    background-color: #38bdf8;
  }
  .theme--dark .covering-zone-badge--zone3 {
    color: #fcd34d;
  }
  .theme--dark .covering-zone-badge--zone3 .covering-zone-badge__pip {
    background-color: #f59e0b;
  }
</style>
